import useIsWindowGreaterThanWidth from './useIsWindowGreaterThanWidth';

export const MOBILE_VIEW_FROM = 600;

function useIsMobile(widthProp = MOBILE_VIEW_FROM) {
  return !useIsWindowGreaterThanWidth(widthProp);
}

export default useIsMobile;
